module.exports = __webpack_public_path__ + "img/Ac.4fb54962.png";